(function () {
  const cacheKey = 'walnutry_shipping_location_v1';
  const cacheMaxAge = 1000 * 60 * 60 * 24 * 7;

  function getCachedLocation() {
    try {
      const cached = JSON.parse(window.localStorage.getItem(cacheKey) || 'null');
      if (!cached || !cached.label || !cached.savedAt) return null;
      if (Date.now() - cached.savedAt > cacheMaxAge) return null;
      return cached;
    } catch (error) {
      return null;
    }
  }

  function setCachedLocation(location) {
    try {
      window.localStorage.setItem(cacheKey, JSON.stringify({
        label: location.label,
        savedAt: Date.now()
      }));
    } catch (error) {
      // Storage can be unavailable in private browsing; the default label still works.
    }
  }

  function setLabel(root, label) {
    const labelEl = root.querySelector('[data-shipping-location-label]');
    if (labelEl && label) labelEl.textContent = label;
  }

  function toggleForm(root, forceOpen) {
    const form = root.querySelector('[data-shipping-location-form]');
    const input = root.querySelector('[data-shipping-location-input]');
    if (!form) return;

    const shouldOpen = typeof forceOpen === 'boolean' ? forceOpen : form.hidden;
    form.hidden = !shouldOpen;
    if (shouldOpen && input) input.focus();
  }

  function formatLocation(address) {
    const zip = address.postcode || '';
    const city = address.city || address.town || address.village || address.hamlet || address.county || '';

    if (zip && city) return `${zip}-${city}`;
    if (city) return city;
    if (zip) return zip;
    return '';
  }

  async function reverseGeocode(latitude, longitude) {
    const url = new URL('https://nominatim.openstreetmap.org/reverse');
    url.searchParams.set('format', 'jsonv2');
    url.searchParams.set('lat', latitude);
    url.searchParams.set('lon', longitude);
    url.searchParams.set('zoom', '18');
    url.searchParams.set('addressdetails', '1');

    const response = await fetch(url.toString(), { method: 'GET' });
    if (!response.ok) throw new Error('Reverse geocoding failed');

    const data = await response.json();
    return formatLocation(data.address || {});
  }

  async function geocodeZip(zip) {
    const url = new URL('https://nominatim.openstreetmap.org/search');
    url.searchParams.set('format', 'jsonv2');
    url.searchParams.set('countrycodes', 'us');
    url.searchParams.set('postalcode', zip);
    url.searchParams.set('addressdetails', '1');
    url.searchParams.set('limit', '1');

    const response = await fetch(url.toString(), { method: 'GET' });
    if (!response.ok) throw new Error('ZIP geocoding failed');

    const data = await response.json();
    if (!Array.isArray(data) || !data[0]) return zip;

    const label = formatLocation(data[0].address || {});
    return label || zip;
  }

  function requestLocation(root) {
    if (!navigator.geolocation) return;

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        try {
          const label = await reverseGeocode(position.coords.latitude, position.coords.longitude);
          if (!label) return;

          setLabel(root, label);
          setCachedLocation({ label });
        } catch (error) {
          setLabel(root, root.dataset.defaultLabel);
        }
      },
      () => {
        setLabel(root, root.dataset.defaultLabel);
      },
      {
        enableHighAccuracy: false,
        timeout: 7000,
        maximumAge: 1000 * 60 * 60 * 24
      }
    );
  }

  function initShippingLocation(root) {
    const cached = getCachedLocation();
    if (cached) {
      setLabel(root, cached.label);
    } else {
      setLabel(root, root.dataset.defaultLabel);
      requestLocation(root);
    }

    const trigger = root.querySelector('[data-shipping-location-trigger]');
    if (trigger) {
      trigger.addEventListener('click', () => toggleForm(root));
    }

    const form = root.querySelector('[data-shipping-location-form]');
    const input = root.querySelector('[data-shipping-location-input]');
    if (form && input) {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const zip = input.value.trim();
        if (!zip) return;

        try {
          const label = await geocodeZip(zip);
          setLabel(root, label);
          setCachedLocation({ label });
        } catch (error) {
          setLabel(root, zip);
          setCachedLocation({ label: zip });
        }

        toggleForm(root, false);
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-shipping-location]').forEach(initShippingLocation);
  });
}());
